import React, { useState } from 'react';

import Settings from 'features/settings/Settings';
import { useAuth } from 'hooks';
import { useTranslation } from 'react-i18next';

import { AppBar, IconButton, Toolbar, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import AccountCircle from '@material-ui/icons/AccountCircle';
import SettingsIcon from '@material-ui/icons/Settings';

import UserMenu from './UserMenu';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      justifyContent: 'space-between',
    },
    fragnet: {
      marginRight: theme.spacing(2),
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  }),
);

interface Props {
  children: React.ReactNode;
}

export default ({ children }: Readonly<Props>) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { isAuthenticated } = useAuth();

  const [settingsModalOpen, setSettingsModalOpen] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  return (
    <>
      <AppBar position="static">
        <Toolbar className={classes.root} variant="dense">
          <div>
            <Typography className={classes.fragnet} display="inline" variant="h6">
              {t('fragnet')}
            </Typography>
            <Typography
              display="inline"
              variant="subtitle2"
            >{`v${process.env.REACT_APP_VERSION}`}</Typography>
          </div>
          {children}
          <div>
            {isAuthenticated && (
              <IconButton
                aria-label="Show application settings"
                color="inherit"
                onClick={() => setSettingsModalOpen(true)}
              >
                <SettingsIcon />
              </IconButton>
            )}

            <IconButton
              edge="end"
              aria-label="account of current user"
              aria-owns={!!anchorEl ? 'profile-popover' : undefined}
              aria-haspopup="true"
              onClick={(event) => setAnchorEl(event.currentTarget)}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      <UserMenu anchorEl={anchorEl} isMenuOpen={!!anchorEl} handleClose={() => setAnchorEl(null)} />
      <Settings open={settingsModalOpen} setOpen={setSettingsModalOpen} />
    </>
  );
};
